import axios from 'axios'

export default {
  getPhillyHoods: () => {
    return new Promise(function (resolve, reject) {
      const centralAxiosInstance = axios.create({
        headers: {'Content-Type': 'application/json; charset=utf-8'},
        responseType: 'json'
      })
      axios.all([
        centralAxiosInstance.get('/static/data/Council_Districts_2016.geojson'),
        centralAxiosInstance.get('/static/data/Neighborhoods_Philadelphia.geojson'),
        centralAxiosInstance.get('/static/data/City_Limits.geojson')
      ])
      .then(axios.spread((council, hoods, limits) => {
        resolve({
          'council': council.data,
          'hoods': hoods.data,
          'limits': limits.data
        })
      }))
      .catch(errorOrCancel => {
        if (axios.isCancel(errorOrCancel)) {
          reject('canceled')
        } else {
          console.error('Axios or processing response error...', errorOrCancel)
          reject(errorOrCancel)
        }
      })
    })
  },
  getProblemData: () => {
    return new Promise(function (resolve, reject) {
      const centralAxiosInstance = axios.create({
        headers: {'Content-Type': 'application/json; charset=utf-8'},
        responseType: 'json'
      })
      centralAxiosInstance.get('/static/data/problems.json')
      .then(response => {
        resolve(response.data)
      })
      .catch(errorOrCancel => {
        if (axios.isCancel(errorOrCancel)) {
          reject('canceled')
        } else {
          console.error('Axios or processing response error...', errorOrCancel)
          reject(errorOrCancel)
        }
      })
    })
  },
  getProblemImageData: () => {
    return new Promise(function (resolve, reject) {
      const centralAxiosInstance = axios.create({
        headers: {'Content-Type': 'application/json; charset=utf-8'},
        responseType: 'json'
      })
      centralAxiosInstance.get('/static/data/problem-images.json')
      .then(response => {
        resolve(response.data)
      })
      .catch(errorOrCancel => {
        if (axios.isCancel(errorOrCancel)) {
          reject('canceled')
        } else {
          console.error('Axios or processing response error...', errorOrCancel)
          reject(errorOrCancel)
        }
      })
    })
  }
}